import { createSelector } from 'reselect'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

export const getId = (state, props) => {
  return props.cardContext.id
}

export const getListId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].listId
}

export const getName = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].name
}

export const getElements = (state, props) => {
  return state['view-card'].elements[props.cardContext.id].elements
}

const getCardsById = (state, props) => {
  return state['view-board'].cards
}

export const cardIdsInListSelector = createSelector(
  [getListId, getIsArchived, getIsTemplate, getCardsById],
  (listId, isArchived, isTemplate, cardsById) =>
    (!isArchived && !isTemplate && listId)
      ? Object.keys(cardsById)
        .filter(key => cardsById[key].listId === listId)
        .sort((a, b) => cardsById[a].position - cardsById[b].position)
        .map(Number)
      : null
)

export default () => createSelector(
  [
    getIsArchived,
    getId,
    cardIdsInListSelector,
    getName,
    getElements,
    getIsTemplate,
  ],
  (
    isArchived,
    id,
    cardIdsInList,
    name,
    elements,
    isTemplate,
  ) => ({
    isArchived,
    id,
    cardIdsInList,
    name,
    elements,
    isTemplate,
  })
)
